export var MAX_VISIBLE_SUGGESTIONS_DESKTOP = 4;
export var MAX_VISIBLE_SUGGESTIONS_MOBILE = 10;
export var DEVIATION_SUGGESTIONS_I18N_KEYS = [
    'commentbox.suggestions.deviation.1',
    'commentbox.suggestions.deviation.2',
    'commentbox.suggestions.deviation.3',
    'commentbox.suggestions.deviation.4',
    'commentbox.suggestions.deviation.5',
    'commentbox.suggestions.deviation.6',
    'commentbox.suggestions.deviation.7',
    'commentbox.suggestions.deviation.8',
    'commentbox.suggestions.deviation.9',
    'commentbox.suggestions.deviation.10',
    'commentbox.suggestions.deviation.11',
    'commentbox.suggestions.deviation.12',
    'commentbox.suggestions.deviation.13',
    'commentbox.suggestions.deviation.14',
    'commentbox.suggestions.deviation.15',
    'commentbox.suggestions.deviation.16',
    'commentbox.suggestions.deviation.17',
    'commentbox.suggestions.deviation.18',
    'commentbox.suggestions.deviation.19',
    'commentbox.suggestions.deviation.20',
    'commentbox.suggestions.deviation.21',
    'commentbox.suggestions.deviation.22',
];
//# sourceMappingURL=constants.js.map